export const ACTION = 'check availability';
export const RENTAL_INTENT_POD_CHECK_AVAILABILITY = 'rental-intent-pod.check-availability';
export const NO_RENTAL = 'rental intent no rentals';
export const RENTAL = 'rental intent';
export const NO_RENTAL_URL = '/c/tool_and_truck_rental';